import React from 'react';
import styles from './styles.module.scss';

const PlayIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
            <path d="M16.0383 8.52223L5.92031 2.33473C5.83514 2.28219 5.73749 2.25333 5.63744 2.25111C5.53739 2.2489 5.43856 2.27342 5.35114 2.32214C5.26373 2.37087 5.19089 2.44203 5.14016 2.52829C5.08942 2.61455 5.06261 2.71278 5.0625 2.81286V15.1879C5.06261 15.2879 5.08942 15.3862 5.14016 15.4724C5.19089 15.5587 5.26373 15.6298 5.35114 15.6786C5.43856 15.7273 5.53739 15.7518 5.63744 15.7496C5.73749 15.7474 5.83514 15.7185 5.92031 15.666L16.0383 9.47848C16.1214 9.42935 16.1902 9.35942 16.238 9.27558C16.2859 9.19174 16.311 9.09688 16.311 9.00036C16.311 8.90383 16.2859 8.80898 16.238 8.72514C16.1902 8.6413 16.1214 8.57136 16.0383 8.52223V8.52223Z" stroke="white" strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
}

const PauseIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
            <path fillRule="evenodd" clipRule="evenodd" d="M4.82006 1.68752C4.83813 1.68753 4.85645 1.68754 4.87504 1.68754C4.89361 1.68754 4.91193 1.68753 4.92999 1.68752C5.22454 1.68737 5.45178 1.68726 5.65241 1.72717C6.47026 1.88985 7.11035 2.52884 7.27316 3.34733C7.31282 3.54669 7.3127 3.77242 7.31255 4.06173C7.31254 4.07953 7.31254 4.09757 7.31254 4.11586V13.8842C7.31254 13.9025 7.31254 13.9205 7.31255 13.9383C7.3127 14.2276 7.31282 14.4531 7.27316 14.6524C7.11045 15.4704 6.4711 16.1104 5.65274 16.2732C5.45211 16.3131 5.22423 16.313 4.92969 16.3128C4.91162 16.3128 4.89329 16.3128 4.8747 16.3128C4.85612 16.3128 4.8378 16.3128 4.81973 16.3128C4.5252 16.313 4.29795 16.3131 4.09733 16.2732C3.27884 16.1104 2.63985 15.4703 2.47717 14.6524C2.43726 14.4518 2.43737 14.2245 2.43752 13.93C2.43753 13.9119 2.43754 13.8936 2.43754 13.875V4.12504C2.43754 4.10645 2.43753 4.08813 2.43752 4.07006C2.43737 3.77552 2.43726 3.54796 2.47717 3.34733C2.63991 2.52915 3.27915 1.88991 4.09733 1.72717C4.29796 1.68726 4.52552 1.68737 4.82006 1.68752ZM4.87504 2.81254C4.49955 2.81254 4.39366 2.81526 4.31681 2.83055C3.94491 2.90452 3.65452 3.19491 3.58055 3.5668C3.56526 3.64366 3.56254 3.74955 3.56254 4.12504V13.875C3.56254 14.2505 3.56526 14.3561 3.58055 14.4329C3.65459 14.8051 3.94523 15.0959 4.31681 15.1698C4.39367 15.1851 4.49925 15.1878 4.8747 15.1878C5.25022 15.1878 5.35642 15.1851 5.43327 15.1698C5.80498 15.0958 6.09577 14.805 6.16978 14.4329C6.18482 14.3573 6.18754 14.2534 6.18754 13.8842V4.11586C6.18754 3.74665 6.18482 3.64242 6.16978 3.5668C6.09587 3.19523 5.80515 2.90459 5.43293 2.83055C5.35607 2.81526 5.25049 2.81254 4.87504 2.81254ZM13.0701 1.68752C13.0881 1.68753 13.1065 1.68754 13.125 1.68754C13.1436 1.68754 13.1619 1.68753 13.18 1.68752C13.4745 1.68737 13.7018 1.68726 13.9024 1.72717C14.7203 1.88985 15.3604 2.52884 15.5232 3.34733C15.5628 3.54669 15.5627 3.77242 15.5626 4.06174C15.5625 4.07954 15.5625 4.09758 15.5625 4.11586V13.8842C15.5625 13.9025 15.5625 13.9205 15.5626 13.9383C15.5627 14.2276 15.5628 14.453 15.5232 14.6524C15.3605 15.4704 14.7211 16.1104 13.9027 16.2732C13.7021 16.3131 13.4742 16.313 13.1797 16.3128C13.1616 16.3128 13.1433 16.3128 13.1247 16.3128C13.1061 16.3128 13.0878 16.3128 13.0697 16.3128C12.7752 16.313 12.548 16.3131 12.3473 16.2732C11.5288 16.1104 10.8898 15.4703 10.7272 14.6524C10.6873 14.4518 10.6874 14.2245 10.6875 13.93C10.6875 13.9119 10.6875 13.8936 10.6875 13.875V4.12504C10.6875 4.10645 10.6875 4.08813 10.6875 4.07006C10.6874 3.77552 10.6873 3.54796 10.7272 3.34733C10.8899 2.52915 11.5292 1.88991 12.3473 1.72717C12.548 1.68726 12.7755 1.68737 13.0701 1.68752ZM13.125 2.81254C12.7495 2.81254 12.6437 2.81526 12.5668 2.83055C12.1949 2.90452 11.9045 3.19491 11.8306 3.5668C11.8153 3.64366 11.8125 3.74955 11.8125 4.12504V13.875C11.8125 14.2505 11.8153 14.3561 11.8306 14.4329C11.9046 14.8051 12.1952 15.0959 12.5668 15.1698C12.6437 15.1851 12.7493 15.1878 13.1247 15.1878C13.5002 15.1878 13.6064 15.1851 13.6833 15.1698C14.055 15.0958 14.3458 14.805 14.4198 14.4329C14.4348 14.3573 14.4375 14.2534 14.4375 13.8842V4.11585C14.4375 3.74666 14.4348 3.64242 14.4198 3.5668C14.3459 3.19523 14.0551 2.90459 13.6829 2.83055C13.6061 2.81526 13.5005 2.81254 13.125 2.81254Z" fill="white"/>
        </svg>
    )
}

const DecreaseIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z" stroke="black" strokeWidth="1.5" strokeMiterlimit="10"/>
            <path d="M8.25 12H15.75" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
};

const IncreaseIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z" stroke="#1E1E1E" strokeWidth="1.5" strokeMiterlimit="10"/>
            <path d="M8.25 12H15.75" stroke="#1E1E1E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M12 8.25V15.75" stroke="#1E1E1E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
}

export const formatTime = (timeInSeconds:number) => {
    const minutes = Math.floor(timeInSeconds / 60);
    const seconds = Math.floor(timeInSeconds % 60);
    return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
};

interface IProps {
    duration: number;
    handleTogglePlay: () => void;
    volume: number;
    handleIncreaseVolume: () => void;
    handleDecreaseVolume: () => void;
    currentTime: number;
    handlePlaybackRate: (value:number) => void;
    playbackRate: number;
    isPlaying: boolean;
}


const PlayerActions = ({duration, handleTogglePlay, volume, handleDecreaseVolume, handleIncreaseVolume, currentTime, handlePlaybackRate, playbackRate, isPlaying}:IProps) => {

    return (
        <div className={styles.player}>
            <div className={styles.player__main}>
                <div className={styles.player__play}>
                    <button
                        className={styles.player__play_btn}
                        type='button'
                        onClick={handleTogglePlay}
                    >
                        {isPlaying ? <PauseIcon/> : <PlayIcon />}
                    </button>
                    <div className={styles.player__play_time}>
                        <span className={styles.player__current}>
                            {formatTime(currentTime)}
                        </span>
                        <span> /</span>
                        <span className={styles.player__full}>
                             {formatTime(duration)}
                        </span>
                    </div>
                    <div className={styles.player__increase}>
                        <button
                            className={` ${playbackRate === 1 ? styles.player__x_active : styles.player__x}`}
                            onClick={() => handlePlaybackRate(1)}
                        >
                            1x
                        </button>
                        <button
                            className={` ${playbackRate === 1.25 ? styles.player__x_active : styles.player__x}`}
                            onClick={() => handlePlaybackRate(1.25)}
                        >
                            1.25x
                        </button>
                        <button
                            className={` ${playbackRate === 1.5 ? styles.player__x_active : styles.player__x}`}
                            onClick={() => handlePlaybackRate(1.5)}
                        >
                            1.5x
                        </button>
                        <button
                            className={` ${playbackRate === 2 ? styles.player__x_active : styles.player__x}`}
                            onClick={() => handlePlaybackRate(2)}
                        >
                            2x
                        </button>
                        <button
                            className={` ${playbackRate === 3 ? styles.player__x_active : styles.player__x}`}
                            onClick={() => handlePlaybackRate(3)}
                        >
                            3x
                        </button>
                    </div>
                </div>
            </div>
            <div className={styles.player__volume}>
                <button
                    type={'button'}
                    className={styles.player__volume_btn}
                    onClick={handleDecreaseVolume}
                >
                    <DecreaseIcon />
                </button>
                <span className={styles.player__volume_value}>
                    {(volume * 100).toFixed()}%
                </span>
                <button
                    type={'button'}
                    className={styles.player__volume_btn}
                    onClick={handleIncreaseVolume}
                >
                    <IncreaseIcon />
                </button>
            </div>
        </div>
    );
};

export default PlayerActions;
